import { render, staticRenderFns } from "./FeatureProReminder.vue?vue&type=template&id=0c21ca64&"
import script from "./FeatureProReminder.vue?vue&type=script&lang=js&"
export * from "./FeatureProReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports